import { RunStatus, SourceFreshnessRunStatus, TestResult } from '../../types';
import { StatusChip } from '../Chip';

export const statusValueRenderer = (
  value: RunStatus | SourceFreshnessRunStatus | 'success',
  size?: 'small' | 'medium',
) => <StatusChip status={value} size={size} />;

const statusRenderer = (value: TestResult, size?: 'small' | 'medium') =>
  statusValueRenderer(value.metadata.latest_run_status, size);

export default statusRenderer;
